// extracted by mini-css-extract-plugin
export default {"filterBYdate":"BS_app_filterBYdate__ssICV","AP_Filters_search":"BS_app_AP_Filters_search__oT36H","datesinput":"BS_app_datesinput__PdEif","serchInp":"BS_app_serchInp__lvrT0"};